








import { defineComponent, onMounted } from "@vue/composition-api";
import logger from "@/modules/logger";

export default defineComponent({
  name: "PageError",
  props: {
    error: { type: Error, required: true },
  },
  setup(props) {
    const errorDate: Date = new Date();

    onMounted(() => logger.debug(props.error, undefined));

    return {
      errorDate,
    };
  },
});
